import { Skeleton } from "@/components/ui/skeleton";

import { PreLaunchMetrics } from "../../../profile/token-pre-launch-overview";
import { useTokenMetrics } from "../use-token-metrics";

export const UpcomingTokenExtraContent = ({
  publicKey,
}: {
  publicKey: string;
}) => {
  const {
    specificCoinLoading,
    uniqueWallets,
    totalBidsFocus,
    focusExchangeRate,
    totalBids,
  } = useTokenMetrics(publicKey);

  return (
    <div className="pt-2">
      {specificCoinLoading ? (
        <>
          <div className="flex flex-col items-center justify-center gap-2">
            <Skeleton className="h-8 w-32" />
            <Skeleton className="h-4 w-48" />
          </div>
          <div className="mt-4 flex flex-row gap-4">
            <Skeleton className="h-24 w-full" />
            <Skeleton className="h-24 w-full" />
          </div>
        </>
      ) : (
        <>
          <PreLaunchMetrics
            wrapperClassName="mt-2"
            {...{
              totalBidsFocus,
              focusExchangeRate: focusExchangeRate ?? 0,
              totalBids,
              uniqueWallets: uniqueWallets.filter(Boolean),
            }}
          />
        </>
      )}
    </div>
  );
};
